"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IllustrationContent = function IllustrationContent() {
  return /*#__PURE__*/_react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "66",
    height: "65",
    fill: "none",
    viewBox: "0 0 66 65"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    width: "65",
    height: "65",
    x: "0.263",
    fill: "#F3F1F5",
    rx: "22"
  }), /*#__PURE__*/_react.default.createElement("path", {
    stroke: "#D5CCDF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M8 52h50"
  }), /*#__PURE__*/_react.default.createElement("path", {
    stroke: "#6F558A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M31.422 40.125H48.64"
  }), /*#__PURE__*/_react.default.createElement("path", {
    stroke: "#6F558A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M31.422 34.781H49.235V52H31.422z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#E2DBE9",
    stroke: "#6F558A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M34.391 43.688H46.266V49.032000000000004H34.391z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#E2DBE9",
    fillRule: "evenodd",
    d: "M39.734 14H17.766v38h13.656V34.781h8.312V14z",
    clipRule: "evenodd"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#6F558A",
    d: "M17.766 14v-.75a.75.75 0 00-.75.75h.75zm21.968 0h.75a.75.75 0 00-.75-.75V14zM17.766 52h-.75c0 .414.335.75.75.75V52zm13.656 0v.75a.75.75 0 00.75-.75h-.75zm0-17.219v-.75a.75.75 0 00-.75.75h.75zm8.312 0v.75a.75.75 0 00.75-.75h-.75zM17.766 14.75h21.968v-1.5H17.766v1.5zm.75 37.25V14h-1.5v38h1.5zm12.906-.75H17.766v1.5h13.656v-1.5zm.75.75V34.781h-1.5V52h1.5zm-.75-16.469h8.312v-1.5h-8.312v1.5zM38.984 14v20.781h1.5V14h-1.5z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    stroke: "#6F558A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M23 26h13M21.328 22.906V16.97M21.328 34.938V29"
  }), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "34.094",
    cy: "37.453",
    r: "0.891",
    fill: "#6F558A"
  }), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "46.563",
    cy: "37.453",
    r: "0.891",
    fill: "#6F558A"
  }), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "38.25",
    cy: "37.453",
    r: "0.891",
    fill: "#6F558A"
  }), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "42.406",
    cy: "37.453",
    r: "0.891",
    fill: "#6F558A"
  }));
};

var _default = IllustrationContent;
exports.default = _default;